import { useMemo } from 'react';

import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { FormikHelpers, FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { ComunicadoTag, initialTagValues } from 'pages/comunicado/tag/types';

export function TagFormComp() {
    const { setContent } = useFormContext();
    const url = '/gestao/tagcomunicado';
    const { id } = useParams();
    const { mutate } = useFormMutation();

    const handleSubmit = (values: ComunicadoTag, formik: FormikHelpers<ComunicadoTag>): void => {
        mutate(
            {
                url,
                idField: 'idTagComunicado',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data) {
                        setContent(data);
                    }
                },
            },
        );
    };

    const validationSchema = useMemo(
        (): any =>
            Yup.object({
                dsTagComunicado: Yup.string().required(),
            }),
        [],
    );

    return (
        <FormPage
            title="Tags Comunicado"
            values={initialTagValues}
            onSubmit={handleSubmit}
            url={url}
            validationSchema={validationSchema}
            goBackButton
        >
            {(formik: FormikProps<ComunicadoTag>) => {
                return (
                    <Block>
                        <Row>
                            {id && (
                                <Grid sx={{ flex: 1 }}>
                                    <CissTextField label="Código" name="idTagComunicado" value={id} disabled={true} />
                                </Grid>
                            )}

                            <Grid sx={{ flex: 4 }}>
                                <CissTextField
                                    label="Tag"
                                    name="dsTagComunicado"
                                    value={formik.values.dsTagComunicado}
                                    error={formik.errors.dsTagComunicado}
                                    onChange={(e) => formik.setFieldValue('dsTagComunicado', e.target.value)}
                                />
                            </Grid>
                        </Row>
                    </Block>
                );
            }}
        </FormPage>
    );
}
